$("._show-clinic-dropdown").click(function () {
    $(this).addClass("_show")
})

$("._show-clinic-dropdown").mouseover(function () {
    $(this).addClass("_show")
})

$("._show-clinic-dropdown").mouseleave(function () {
    $(this).removeClass("_show")
})

$(".lang").mouseover(function () {
    $(this).addClass("_show")
})

$(".lang").mouseleave(function () {
    $(this).removeClass("_show")
})

$(".nav2__more").mouseover(function () {
    $(this).addClass("_show")
})

$(".nav2__more").mouseleave(function () {
    $(this).removeClass("_show")
})

$(".header__burger").click(function () {
    $(".header").toggleClass("_open-menu")
    $("body").toggleClass("fixed-body")
    $("html").toggleClass("fixed-body")
    $(".submenu").fadeOut()
    $(".header").removeClass("_open-submenu")
})


$(".menu [data-target]").click(function (e) {
    e.preventDefault()
    let submenuId = $(this).attr("data-target")
    console.log(submenuId)
    $(`.submenu[data-id="${submenuId}"]`).fadeIn()
    $(".header").addClass("_open-submenu")
})

$(".submenu__back").click(function () {
    $(".submenu").fadeOut()
    $(".header").removeClass("_open-submenu")
})

$(".header__search-btn").click(function () {
    $(".header").toggleClass("_open-search")
    $("body").toggleClass("fixed-body")
    $("html").toggleClass("fixed-body")
})

$("._search-field").on('input',function () {
    let val = $(this).val().trim()
    if(val === ""){
        $(".header-search").removeClass("_founded")
        return
    }

    $(".header-search").addClass("_founded")
})

let isFormFocused = false;
$('._search-field').focus(function() {
    if(!isFormFocused) {
        // Форма получила фокус, делаем здесь что нужно
        isFormFocused = true;
        console.log(isFormFocused)
        $("body").bind('touchmove', function (e) {
            e.preventDefault()
        });
    }
});
$('._search-field').blur(function() {
    if(0 === $('._search-field:focus').length) {
        // Форма потеряла фокус
        isFormFocused = false;
        console.log(isFormFocused)
        $("body").unbind('touchmove');
    }
});

$("._clear-search").click(function () {
    $(".header-search").removeClass("_founded")
    $("._search-field").val('')
})

$(".menu__chapters-toggle").click(function () {
    $(this).toggleClass("_active")
    $(this).siblings(".menu__chapters-dropdown").slideToggle()
})
